import Tracking from "@/types/tracking/tracking"
import ExportTracking from "@/types/tracking/exportTracking"
import { DateAndTimeHelper } from "@/helpers/DateAndTimeHelper"
import ExportExpenditure from "@/types/expenditure/exportExpenditure"

const dateTimeHelper = new DateAndTimeHelper()

export function prepareTrackingData (client: string, trackedTimes: Tracking[]): { exportEntries: ExportTracking[], total: string, totalTime: number } {
  let total = 0
  let totalTime = 0
  const exportTrackings: ExportTracking[] = []
  trackedTimes.forEach((time) => {
    if (!time.startingTime || !time.endTime) return
    exportTrackings.push(new ExportTracking({
      date: dateTimeHelper.getReadableDateFromStartingTime(time.startingTime),
      client: client,
      task: time.task,
      started: dateTimeHelper.getReadableTimeFromStartingTime(time.startingTime),
      stopped: dateTimeHelper.getReadableTimeFromStartingTime(Number(time.endTime)),
      time: dateTimeHelper.timeStringToNumber(dateTimeHelper.getTrackedTimeWithoutSeconds(time.startingTime, Number(time.endTime))),
      total: Number(time.making)
    }))
    total += Number(time.making)
    totalTime += dateTimeHelper.timeStringToNumber(dateTimeHelper.getTrackedTimeWithoutSeconds(time.startingTime, Number(time.endTime)))
  })
  return {
    exportEntries: exportTrackings,
    total: formatCurrency(total),
    totalTime: totalTime
  }
}

export function prepareExpenditureData (trackings: Tracking[]): { expenditureEntries: ExportExpenditure[], total: string } {
  const expenditureEntries: any[] = []
  let total = 0

  trackings.forEach((tracking) => {
    if (!tracking || !tracking.expenditures) return
    tracking.expenditures.forEach((expenditure) => {
      if (!tracking.startingTime || !expenditure.positionPrice || !expenditure.totalPrice) return
      expenditureEntries.push(
        {
          date: dateTimeHelper.getReadableDateFromStartingTime(tracking.startingTime),
          quantity: Number(expenditure.quantity),
          position: expenditure.position,
          positionPrice: expenditure.positionPrice,
          totalPrice: expenditure.totalPrice
        }
      )
      total += expenditure.totalPrice
    })
  })

  return {
    expenditureEntries: expenditureEntries,
    total: formatCurrency(total)
  }
}

function formatCurrency (value: number) {
  return Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(value)
}
